export const V_LAYOUTS = {
	ZERO: 'wallpaper',
	ONE: {
		FULL: 'single cover',
		FULL_PADDING: 'single-padding cover',
		HALF: 'half cover',
	},
	TWO: {
		FULL_TWO: 'double cover',
		VERTICAL: {
			COVER: 'vertical two cover',
			CONTAIN: 'vertical two contain',
		},
		HORIZONTAL: {
			COVER: 'horizontal two cover',
			CONTAIN: 'horizontal two contain',
		},
		STACK: {
			RIGHT: {
				CONTAIN: 'stack two right contain',
			},
		},
		SHIFTED: 'horizontal two-shifted contain',
		SPACED: 'horizontal two spaced',
		// We check for "media" in these type names in main-video to ignore
		// spacing layouts since these are already calculated for media proportions.
		// So if changing the name of these, keep "media" in them.
		MEDIA: {
			SIXTEEN_BY_NINE: 'media two sixteen-by-nine cover',
			FOUR_BY_THREE: 'media two four-by-three cover',
		},
		PICTURE_IN_PICTURE: {
			BOTTOM_RIGHT: 'picture-in-picture bottom right',
			TOP_LEFT: 'picture-in-picture top left',
		},
	},
	THREE: {
		VERTICAL: {
			COVER: 'vertical three cover',
			CONTAIN: 'vertical three contain',
		},
		HORIZONTAL: {
			COVER: 'horizontal three cover',
			CONTAIN: 'horizontal three contain',
		},
		STACK: {
			LEFT: 'stack three left',
			RIGHT: 'stack three right',
			TOP: 'stack three top',
		},
		SPACED: 'horizontal three spaced',
		// We check for "media" in these type names in main-video to ignore
		// spacing layouts since these are already calculated for media proportions.
		// So if changing the name of these, keep "media" in them.
		MEDIA: {
			SIXTEEN_BY_NINE: 'media three sixteen-by-nine cover',
			FOUR_BY_THREE: 'media three four-by-three cover',
		},
		ASL: {
			DOUBLE_FOUR_BY_THREE: 'asl fixed three double-four-by-three cover',
		},
	},
	FOUR: {
		GRID: 'grid four',
		VERTICAL: {
			COVER: 'vertical four cover',
		},
		SPIRAL: 'spiral four',
		// We check for "media" in these type names in main-video to ignore
		// spacing layouts since these are already calculated for media proportions.
		// So if changing the name of these, keep "media" in them.
		MEDIA: {
			SIXTEEN_BY_NINE: 'media four sixteen-by-nine cover',
			FOUR_BY_THREE: 'media four four-by-three cover',
		},
		ASL: {
			THREE_BY_FOUR: 'asl fixed four three-by-four cover',
			SIXTEEN_BY_NINE: 'asl fixed four sixteen-by-nine cover',
		},
	},
	FIVE: {
		STACK: {
			RIGHT: 'stack five right',
			TOP_LEFT: 'stack five top-left',
			TWO_LEFT: 'stack five two-left',
			FOUR_TOP: 'stack five four-top',
			FOUR_BY_THREE: 'stack five four-by-three cover',
		},
		ASL: {
			NINE_BY_SIXTEEN: 'asl fixed five nine-by-sixteen cover',
		},
	},
	SIX: {
		GRID: 'grid six',
		STACK: {
			RIGHT: 'stack six right',
			LEFT: 'stack six left',
			RANDOM: 'stack six random',
		},
	},
	SEVEN: {
		GRID: 'grid seven',
		STACK: {
			CENTER: 'stack seven center',
		},
	},
	EIGHT: {
		GRID: 'grid eight',
	},
};

export interface VideoLayouts {
	presenters: number;
	layouts: string[];
}

export const LAYOUTS_BY_SIZE: VideoLayouts[] = [
	{
		presenters: 1,
		layouts: [
			V_LAYOUTS.ONE.FULL,
			V_LAYOUTS.ONE.FULL_PADDING,
			V_LAYOUTS.ONE.HALF,
		],
	},
	{
		presenters: 2,
		layouts: [
			V_LAYOUTS.TWO.VERTICAL.COVER,
			V_LAYOUTS.TWO.STACK.RIGHT.CONTAIN,
			V_LAYOUTS.TWO.HORIZONTAL.CONTAIN,
			V_LAYOUTS.TWO.SPACED,
			V_LAYOUTS.TWO.MEDIA.SIXTEEN_BY_NINE,
			V_LAYOUTS.TWO.MEDIA.FOUR_BY_THREE,
			V_LAYOUTS.TWO.PICTURE_IN_PICTURE.BOTTOM_RIGHT,
			V_LAYOUTS.TWO.PICTURE_IN_PICTURE.TOP_LEFT,
		],
	},
	{
		presenters: 3,
		layouts: [
			V_LAYOUTS.THREE.VERTICAL.COVER,
			V_LAYOUTS.THREE.STACK.TOP,
			V_LAYOUTS.THREE.STACK.LEFT,
			V_LAYOUTS.THREE.STACK.RIGHT,
			V_LAYOUTS.THREE.SPACED,
			V_LAYOUTS.THREE.MEDIA.SIXTEEN_BY_NINE,
			V_LAYOUTS.THREE.MEDIA.FOUR_BY_THREE,
			V_LAYOUTS.THREE.ASL.DOUBLE_FOUR_BY_THREE,
		],
	},
	{
		presenters: 4,
		layouts: [
			V_LAYOUTS.FOUR.GRID,
			V_LAYOUTS.FOUR.VERTICAL.COVER,
			V_LAYOUTS.FOUR.SPIRAL,
			V_LAYOUTS.FOUR.MEDIA.SIXTEEN_BY_NINE,
			V_LAYOUTS.FOUR.MEDIA.FOUR_BY_THREE,
			V_LAYOUTS.FOUR.ASL.THREE_BY_FOUR,
			V_LAYOUTS.FOUR.ASL.SIXTEEN_BY_NINE,
		],
	},
	{
		presenters: 5,
		layouts: [
			V_LAYOUTS.FIVE.STACK.FOUR_BY_THREE,
			V_LAYOUTS.FIVE.STACK.RIGHT,
			V_LAYOUTS.FIVE.STACK.TOP_LEFT,
			V_LAYOUTS.FIVE.STACK.TWO_LEFT,
			V_LAYOUTS.FIVE.STACK.FOUR_TOP,
			V_LAYOUTS.FIVE.ASL.NINE_BY_SIXTEEN,
		],
	},
	{
		presenters: 6,
		layouts: [
			V_LAYOUTS.SIX.GRID,
			V_LAYOUTS.SIX.STACK.RIGHT,
			V_LAYOUTS.SIX.STACK.LEFT,
			V_LAYOUTS.SIX.STACK.RANDOM,
		],
	},
	{
		presenters: 7,
		layouts: [
			V_LAYOUTS.SEVEN.GRID,
			V_LAYOUTS.SEVEN.STACK.CENTER,
		],
	},
	{
		presenters: 8,
		layouts: [V_LAYOUTS.EIGHT.GRID],
	},
];

export const FIXED_LAYOUTS = [
	V_LAYOUTS.TWO.MEDIA.SIXTEEN_BY_NINE,
	V_LAYOUTS.TWO.MEDIA.FOUR_BY_THREE,
	V_LAYOUTS.THREE.MEDIA.SIXTEEN_BY_NINE,
	V_LAYOUTS.THREE.MEDIA.FOUR_BY_THREE,
	V_LAYOUTS.FOUR.MEDIA.SIXTEEN_BY_NINE,
	V_LAYOUTS.FOUR.MEDIA.FOUR_BY_THREE,
	V_LAYOUTS.THREE.ASL.DOUBLE_FOUR_BY_THREE,
	V_LAYOUTS.FOUR.ASL.THREE_BY_FOUR,
	V_LAYOUTS.FOUR.ASL.SIXTEEN_BY_NINE,
	V_LAYOUTS.FIVE.ASL.NINE_BY_SIXTEEN,
];

export const fixedLayoutTypes = ['fixed', 'media'];

export default V_LAYOUTS;

export function getVisiblePresentersFromLayout(layout: string) {
	let returnedNumber = 0;
	LAYOUTS_BY_SIZE.forEach((layoutGroup: VideoLayouts) => {
		layoutGroup.layouts.forEach((layoutString: string) => {
			if (layoutString === layout) {
				returnedNumber = layoutGroup.presenters;
			}
		});
	});
	return returnedNumber;
}
